
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { ShopifyLinkedService } from 'app/model/linkedservice/shopify.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'ShopifyObject',
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Shopify_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Shopify_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: ShopifyLinkedService.MODEL // Linked service redefined
        }
    }
})
export class ShopifyObjectDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
